module.exports = __webpack_public_path__ + "static/GorditaBold-Italic-94593061f6ec89a255650a18e83fcde5.woff2";